const apiUrl = (url: string): string => (process.env.REACT_APP_API_URL || 'localhost').concat(url);

export default apiUrl;
